import Flex from "common/Boxes/Flex";
import ArrowRightOutlined from "@ant-design/icons/ArrowRightOutlined";
import CardWithTitle from "features/affiliation/common/CardWithTitle";
import React, { useContext } from "react";
import styled from "styled-components";
import { buttonStyles, StyledDefaultButton } from "common/Buttons/Button";
import { AffiliationContext } from "features/affiliation/Affiliation.context";
import useMedia from "utils/hooks/useMedia";
import { getUsdValueWithPrecision } from "features/affiliation/common/utils";
import { SMALL_TITLE_SCREEN } from "features/affiliation/common/constants";
import { ValueTitle } from "features/affiliation/common/styles";
import { MOBILE_SEARCH } from "common/constants";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

const Balance = () => {
  const { balance, onCreatePayoutClick, hasPayoutMethod } =
    useContext(AffiliationContext)!;
  const displayBalance = getUsdValueWithPrecision(balance);
  const longValue = displayBalance.length > 7;
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);

  return (
    <CardWithTitle
      title={t("balance.title")}
      cardStyle={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: isMobile ? 95 : 105,
      }}
      titleStyle={{
        marginBottom: 0,
      }}
    >
      <Flex>
        <ValueTitle $longValue={longValue}>{displayBalance}</ValueTitle>
        <CreatePayoutButton
          onClick={onCreatePayoutClick}
          $disabled={!hasPayoutMethod}
        >
          {t("actions.create_payout")} <ArrowRightOutlined />
        </CreatePayoutButton>
      </Flex>
    </CardWithTitle>
  );
};

export default Balance;

const CreatePayoutButton = styled(StyledDefaultButton)<{
  $disabled: boolean;
}>`
  ${(p) =>
    p.$disabled &&
    `
     ${buttonStyles.antBtnDisabled}
    `};

  @media (max-width: ${SMALL_TITLE_SCREEN}) {
    font-size: ${(p) => p.theme.typography.fontSizes.S};
  }
`;
